import { Box, Button, Typography, useTheme } from "@mui/material";
import dayjs from "dayjs";

const GlobalMobileTimePickerToolbar = (props) => {
  const theme = useTheme();
  const { value, onChange, ampm, disabled, readOnly, view, onViewChange } =
    props;

  const parsedValue = value ? dayjs(value) : null;
  const meridiemMode =
    parsedValue && parsedValue.isValid() && parsedValue.hour() >= 12
      ? "pm"
      : "am";

  const hourLabel =
    parsedValue && parsedValue.isValid()
      ? parsedValue.format(ampm ? "hh" : "HH")
      : "--";
  const minuteLabel =
    parsedValue && parsedValue.isValid() ? parsedValue.format("mm") : "--";

  const toolbarTimeButtonSx = (isSelected) => ({
    minWidth: "auto",
    px: 0,
    py: 0,
    borderRadius: 0,
    textTransform: "none",
    color: isSelected ? theme.palette.text.primary : theme.palette.text.secondary,
    fontWeight: isSelected ? 600 : 400,
    fontSize: "2rem",
    lineHeight: 1,
    "&:hover": {
      backgroundColor: "transparent",
    },
  });

  const meridiemButtonSx = (isSelected) => ({
    minWidth: 56,
    px: 1.5,
    py: 0.25,
    borderRadius: "999px",
    textTransform: "none",
    backgroundColor: isSelected
      ? theme.palette.action.selected
      : "transparent",
    color: isSelected ? theme.palette.text.primary : theme.palette.text.secondary,
    fontWeight: isSelected ? 700 : 400,
    "&:hover": {
      backgroundColor: isSelected
        ? theme.palette.action.selected
        : theme.palette.action.hover,
    },
  });

  const handleMeridiemChange = (nextMode) => {
    if (disabled || readOnly || !parsedValue || !parsedValue.isValid()) {
      return;
    }

    const currentHour = parsedValue.hour();
    let nextHour = currentHour;

    if (nextMode === "am" && currentHour >= 12) {
      nextHour -= 12;
    }

    if (nextMode === "pm" && currentHour < 12) {
      nextHour += 12;
    }

    onChange?.(parsedValue.hour(nextHour));
  };

  return (
    <Box sx={{ px: 2, pt: 1.25, pb: 0.25 }}>
      <Typography
        variant="overline"
        sx={{
          display: "block",
          textAlign: "center",
          color: theme.palette.text.secondary,
          letterSpacing: "0.08em",
          mb: 1,
        }}
      >
        Select Time
      </Typography>

      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: 1.25,
          width: "100%",
          mb: 0.25,
        }}
      >
        {ampm ? (
          <Button
            disableRipple
            disabled={disabled}
            onClick={() => handleMeridiemChange("am")}
            sx={meridiemButtonSx(meridiemMode === "am")}
          >
            AM
          </Button>
        ) : null}

        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
          <Button
            disableRipple
            disabled={disabled}
            onClick={() => onViewChange?.("hours")}
            sx={toolbarTimeButtonSx(view === "hours")}
          >
            {hourLabel}
          </Button>

          <Typography
            sx={{
              color: theme.palette.text.secondary,
              fontSize: "2rem",
              lineHeight: 1,
              mb: 0.15,
            }}
          >
            :
          </Typography>

          <Button
            disableRipple
            disabled={disabled}
            onClick={() => onViewChange?.("minutes")}
            sx={toolbarTimeButtonSx(view === "minutes")}
          >
            {minuteLabel}
          </Button>
        </Box>

        {ampm ? (
          <Button
            disableRipple
            disabled={disabled}
            onClick={() => handleMeridiemChange("pm")}
            sx={meridiemButtonSx(meridiemMode === "pm")}
          >
            PM
          </Button>
        ) : null}
      </Box>
    </Box>
  );
};

export default GlobalMobileTimePickerToolbar;
